const getSnippetFor = (country: string, resultCount: number) => {
    if (country === 'engeland') {
        return snippetForEngland(resultCount);
    }

    if (country === 'wales') {
        return snippetForWales(resultCount);
    }

    if (country === 'schotland') {
        return snippetForScotland(resultCount);
    }

    if (country === 'ierland') {
        return snippetForIreland(resultCount);
    }

    return null;
}

const snippetForEngland = (resultCount) => `
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "Hoeveel vakantiehuizen heeft Cottage Centre in Engeland?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Cottage Centre heeft momenteel ${resultCount} vakantiehuizen in Engeland."
        }
      }, {
        "@type": "Question",
        "name": "Op welke manieren kan ik het beste naar Engeland reizen?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<ul><li>Met de (auto)trein door de kannaaltunnel</li><li>Met de ferry vanaf Duinkerken/Calais naar Dover</li><li>Met de ferry vanaf Europoort naar Hull</li><li>Met de nachtboot vanaf IJmuiden naar Newcastle</li><li>Met het vliegtuig</li></ul>"
        }
      }, {
        "@type": "Question",
        "name": "Heb ik een paspoort nodig als ik naar Engeland reis?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Als u naar Engeland reist is een geldig paspoort nodig."
        }
      }, {
        "@type": "Question",
        "name": "Wat zijn leuke activiteiten om te ondernemen in Engeland?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":"<ul><li>Ga kastelen bezoeken</li><li>Ontdek de blauwe zee en verscholen baaien van Cornwall en Devon</li><li>Ga fossielen zoeken aan de Jurrasic Coast in Dorset</li><li>Bezoek de tuinen in Kent</li><li>Ga wandelen in een van de National Parks</li></ul>"}
        }]
    }
`;

const snippetForWales = (resultCount) => `
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "Hoeveel vakantiehuizen heeft Cottage Centre in Wales?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Cottage Centre heeft momenteel ${resultCount} vakantiehuizen in Wales."
        }
      }, {
        "@type": "Question",
        "name": "Op welke manieren kan ik het beste naar Wales reizen?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<ul><li>Met de (auto)trein door de kannaaltunnel</li><li>Met de ferry vanaf Duinkerken/Calais naar Dover</li><li>Met de ferry vanaf Europoort naar Hull</li><li>Met de nachtboot vanaf IJmuiden naar Newcastle</li><li>Met het vliegtuig</li></ul>"
        }
      }, {
        "@type": "Question",
        "name": "Heb ik een paspoort nodig als ik naar Wales reis?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Als u naar Wales reist is een geldig paspoort nodig."
        }
      }, {
        "@type": "Question",
        "name": "Wat zijn leuke activiteiten om te ondernemen in Wales?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":"<ul><li>Wandel door de glooiende landschappen van de Brecon Beacons</li><li>Bergwandelen in Snowdonia</li><li>Coasteering langs de Pembrokeshire Coast</li><li>Bezoek bruisend Cardiff</li></ul>"}
        }]
    }
`;

const snippetForScotland = (resultCount) => `
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "Hoeveel vakantiehuizen heeft Cottage Centre in Schotland?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Cottage Centre heeft momenteel ${resultCount} vakantiehuizen in Schotland."
        }
      }, {
        "@type": "Question",
        "name": "Op welke manieren kan ik het beste naar Schotland reizen?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<ul><li>Met de ferry vanaf Europoort naar Hull (voor het zuiden van Schotland)</li><li>Met de nachtboot vanaf IJmuiden naar Newcastle (voor de Highlands)</li><li>Met het vliegtuig</li></ul>"
        }
      }, {
        "@type": "Question",
        "name": "Heb ik een paspoort nodig als ik naar Schotland reis?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Als u naar Schotland reist is een geldig paspoort nodig."
        }
      }, {
        "@type": "Question",
        "name": "Wat zijn leuke activiteiten om te ondernemen in Schotland?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":"<ul><li>Hiken en vissen in de Highlands</li><li>Op zoek naar het monster van Loch Ness</li><li>Bezoek historische kastelen</li><li>Bezoek een van de vele whisky destilleerderijen</li><li>Bewandel de High Mile van Edinburgh</li><li>Ontdek de magie van Skye</li></ul>"}
        }]
    }
`;

const snippetForIreland = (resultCount) => `
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "Hoeveel vakantiehuizen heeft Cottage Centre in Ierland?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Cottage Centre heeft momenteel ${resultCount} vakantiehuizen in Ierland."
        }
      }, {
        "@type": "Question",
        "name": "Behoort (Noord) Ierland tot de EU?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sinds 1973 is Ierland lid van de EU en sinds 2002 van de Eurozone. Echter, Noord-Ierland behoort tot het Verenigd Koninkrijk dat met ingang van 1 februari 2020 geen deel meer uit maakt van de EU. Noord-Ierland blijft voor douaneformaliteiten wel onderdeel van de EU."
        }
      }, {
        "@type": "Question",
        "name": "Heb ik een paspoort nodig als ik naar Ierland reis?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Als u naar Ierland reist is een geldige identiteitskaart of geldig paspoort nodig. Reist u via het Verenigd Koninkrijk naar Ierland dan is een geldig paspoort nodig. Als u naar Noord-Ierland reist is een geldig paspoort nodig aangezien dit onderdeel is van het Verenigd Koninkrijk."
        }
      }, {
        "@type": "Question",
        "name": "Wat zijn leuke activiteiten om te ondernemen in (Noord) Ierland?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":"<ul><li>Ontdek de bruisende steden Dublin en Belfast met de hop-on-hop-off bus</li><li>Rijdt en ervaar de Wild Atlantic Way vanuit uw camper of auto</li><li>Bezoek het weidse landschap en de Twelve Bins in de Connemara, waar u de turf overal ruikt en de Ierse taal nog veel gesproken word</li><li>Wandel langs de kliftoppen boven de Giant Causeway in Noord-Ierland</li><li>Bezoek de Game of Thrones Studio Tour in Banbridge Noord-Ierland</li></ul>"}
        }]
    }
`;

export default getSnippetFor;
